/**
 * Created by Abner Sui on 07/23/2020
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { CommentsComponent } from './comments.component';
import { CommentComponent } from './comment.component';
import { PopupModule } from '@progress/kendo-angular-popup';

@NgModule({
    imports: [
        CommonModule,
        PopupModule,
        WidgetsModule,
    ],
    declarations: [
        CommentsComponent,
        CommentComponent,
    ],
    exports: [
        CommentsComponent,
    ],
    providers: []
})
export class CommentsModule { }
